import React from 'react';
import { getAmount } from './helper';

/** Human-readable label for an `amazon_fees` object key (matches dashboard chart breakdown). */
export const formatAmazonFeeLabel = (key) =>
    String(key)
        .replace(/_/g, ' ')
        .replace(/\b\w/g, (c) => c.toUpperCase())
        .replace(/\bFba\b/g, 'FBA');

/** Fee line items from API payload, excluding the rolled-up `total`. */
export const getAmazonFeeBreakdownEntries = (amazonFees) =>
    Object.entries(amazonFees || {}).filter(([key]) => key !== 'total');

/** Ant Design Tooltip `styles.body` for Amazon fee breakdown popovers. */
export const amazonFeesTooltipBodyStyle = {
    minWidth: 300,
    maxWidth: 360,
    padding: '10px 16px',
    boxSizing: 'border-box',
};

const feeRowStyle = {
    display: 'grid',
    gridTemplateColumns: 'minmax(0, 1fr) max-content',
    columnGap: 16,
    alignItems: 'start',
    marginBottom: 6,
    width: '100%',
};

const feeLabelStyle = {
    color: '#a1a5b7',
    wordBreak: 'break-word',
};

const feeValueStyle = {
    whiteSpace: 'nowrap',
    textAlign: 'right',
    minWidth: 72,
    fontWeight: 700,
};

/** Tooltip body for Amazon fee breakdown rows (label wraps; amount stays on one line). */
export const AmazonFeesBreakdownTooltip = ({ amazonFees, currencySign }) => {
    const feeBreakdown = getAmazonFeeBreakdownEntries(amazonFees);

    return (
        <div style={{ width: '100%', boxSizing: 'border-box' }}>
            {feeBreakdown.length > 0 ? feeBreakdown.map(([key, value]) => (
                <div key={key} style={feeRowStyle}>
                    <span style={feeLabelStyle}>{formatAmazonFeeLabel(key)}:</span>
                    <span style={feeValueStyle}>
                        {getAmount(value ?? 0, currencySign)}
                    </span>
                </div>
            )) : (
                <span style={{ color: '#a1a5b7' }}>No fee breakdown available</span>
            )}
        </div>
    );
};
